import React from 'react';
import { Search } from 'lucide-react';

const STATUS_OPTIONS = [
  { value: '', label: 'Todos os status' },
  { value: 1, label: 'Nova' },
  { value: 2, label: 'Em análise' },
  { value: 3, label: 'Atendida' },
  { value: 4, label: 'Encaminhada' },
  { value: 5, label: 'Improcedente' },
  { value: 6, label: 'Não localizada' },
  { value: 7, label: 'Em monitoramento' },
  { value: 8, label: 'Auto de infração' },
  { value: 9, label: 'Arquivada' },
  { value: 10, label: 'Enviada p/ arquivamento' },
  { value: 11, label: 'Enviada p/ jurídico' },
  { value: 12, label: 'Enviada p/ gabinete' },
  { value: 13, label: 'Enviada p/ licenciamento' },
];

const ComplaintFilters = ({ filters, onFiltersChange, categories = [] }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onFiltersChange({
      ...filters,
      [name]: value,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="relative md:col-span-2">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          name="search"
          placeholder="Buscar por local, descrição..."
          value={filters.search || ''}
          onChange={handleChange}
          className="form-input pl-10 w-full"
        />
      </div>
      <div>
        <select
          name="status"
          value={filters.status ?? ''}
          onChange={handleChange}
          className="form-select w-full"
        >
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select
          name="categoryId"
          value={filters.categoryId || ''}
          onChange={handleChange}
          className="form-select w-full"
        >
          <option value="">Todas as categorias</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ComplaintFilters;
